module.exports = __webpack_public_path__ + "static/media/idcard-green-bg-body-olive.0b868e59.png";